import React, { useState, useCallback } from "react";
import {
	SortableContext,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Button } from "../../../components/ui/button";
import { FolderPlus, ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { useServiceCatalogStore } from "../../../store/ServiceCatalog";
import { ServiceCatalogFolderNode } from "./service-catalog-folder-node.component";

export const ServiceCatalogTreePanel: React.FC = () => {
	const tree = useServiceCatalogStore((s) => s.catalog.tree);
	const addFolder = useServiceCatalogStore((s) => s.addFolder);
	const [collapseSignal, setCollapseSignal] = useState(0);
	const [expandSignal, setExpandSignal] = useState(0);

	const handleAddRootFolder = useCallback(() => {
		addFolder(null, "Neuer Ordner");
	}, [addFolder]);

	return (
		<div className="p-4">
			<div className="flex items-center justify-between mb-4">
				<span className="text-sm font-medium text-muted-foreground">
					Katalogstruktur
				</span>
				<div className="flex items-center gap-1">
					{tree.length > 0 && (
						<>
							<Button
								variant="ghost"
								size="icon"
								className="h-8 w-8"
								onClick={() => setExpandSignal((s) => s + 1)}
								aria-label="Alle aufklappen"
								data-testid="catalog-expand-all"
								title="Alle aufklappen"
							>
								<ChevronsUpDown className="h-4 w-4" />
							</Button>
							<Button
								variant="ghost"
								size="icon"
								className="h-8 w-8"
								onClick={() => setCollapseSignal((s) => s + 1)}
								aria-label="Alle zuklappen"
								data-testid="catalog-collapse-all"
								title="Alle zuklappen"
							>
								<ChevronsDownUp className="h-4 w-4" />
							</Button>
						</>
					)}
					<Button
						variant="outline"
						size="sm"
						onClick={handleAddRootFolder}
						aria-label="Neuen Ordner erstellen"
						data-testid="catalog-add-root-folder"
					>
						<FolderPlus className="h-4 w-4 mr-1" />
						Neuer Ordner
					</Button>
				</div>
			</div>

			{tree.length === 0 ? (
				<div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
					<FolderPlus className="h-12 w-12 mb-4 opacity-30" />
					<p className="text-sm max-w-xs">
						Noch keine Ordner erstellt. Erstellen Sie Ihren ersten
						Ordner und ziehen Sie Tarife, Artikel und Vorlagen
						hinein.
					</p>
				</div>
			) : (
				<SortableContext
					items={tree.map((f) => f.id)}
					strategy={verticalListSortingStrategy}
				>
					{tree.map((folder, index) => (
						<ServiceCatalogFolderNode
							key={folder.id}
							folder={folder}
							parentId={null}
							index={index}
							depth={0}
							collapseSignal={collapseSignal}
							expandSignal={expandSignal}
						/>
					))}
				</SortableContext>
			)}
		</div>
	);
};
